import { StationItemNo, StationVisual } from './gameStation';
import { STATION_DOORS } from './stationDoor';
import { STATION_EMPTYS } from './stationEmpty';
import { STATION_GAMES } from './stationGame';
import { STATION_GOALS } from './stationGoal';
import { STATION_MINI_CHALLENGES } from './stationMiniChallenge';
import { STATION_REWARDS } from './stationReward';
import { STATION_RULES } from './stationRule';
import { STATION_SLIDESHOWS } from './stationSlideshow';
import { STATION_STARTS } from './stationStart';
import { STATION_SUPER_CHALLENGES } from './stationSuperChallenge';
import { STATION_TUTORS } from './stationTutor';

const combinedItems = [
  ...STATION_EMPTYS,
  ...STATION_DOORS,
  ...STATION_GAMES,
  ...STATION_GOALS,
  ...STATION_MINI_CHALLENGES,
  ...STATION_REWARDS,
  ...STATION_RULES,
  ...STATION_SLIDESHOWS,
  ...STATION_STARTS,
  ...STATION_SUPER_CHALLENGES,
  ...STATION_TUTORS,
];

export const stationItemsMap = new Map(
  combinedItems.map((item) => [item.itemId, item]),
);

export const getStationVisual = (
  itemId: StationItemNo,
): StationVisual | undefined => {
  const item = stationItemsMap.get(itemId);
  return item?.visual;
};
